import i18n from 'i18next';
import Backend from './backend';
import { getTranslationOverrideFromSource } from '@awarego-ui/components';

let instance;

function init(commonStore) {
    i18n.use({
        type: 'postProcessor',
        name: 'companyOverrides',
        process(value, key, options) {
            try {
                const brandingStore = window.__stores?.brandingStore;
                const lng =
                    options?.lng ||
                    i18n.language ||
                    window.localStorage.getItem('language') ||
                    'en';
                const normalizedKey = Array.isArray(key) ? key[0] : key;
                const override = getTranslationOverrideFromSource(
                    brandingStore?.branding,
                    lng,
                    normalizedKey
                );
                if (override !== undefined && override !== null && override !== '') {
                    return override;
                }
                if (!brandingStore?.brandingLoaded) {
                    return value;
                }

                return value;
            } catch (error) {
                console.error('Error in companyOverrides processor:', error);
                return value;
            }
        },
    });

    instance = i18n.use(Backend).init({
        react: {
            useSuspense: false,
        },
        lng: window.localStorage.getItem('language') || 'en',
        fallbackLng: 'en',
        // load: "languageOnly",
        ns: ['common', 'assessment'],
        defaultNS: 'common',
        keySeparator: false,
        postProcess: ['companyOverrides'],
        backend: {
            loadPath: `/static/locales/{{lng}}/{{ns}}.json`,
            commonStore,
        },
        debug: false,
    });
    return instance;
}

export default { init };
